(function () {
  'use strict';

  angular
      .module('tfc.Nav')
      .controller('PageWithMenuCtrl', PageWithMenuCtrl);

  // @ngInject
  function PageWithMenuCtrl(LookAndFeel) {
    LookAndFeel.setToBrandMetrics();
  }
})();
